import { Link } from 'react-router-dom';
import { useSite } from './useSiteContent';

/**
 * The front door (screen 01): one promise, a product shot, three pillars.
 *
 * The words and the shot are Site content's (078) — edited and published in
 * Platform › Site content › Site › Home; the launch copy lives on as the
 * fallback in shared/siteContent.ts. What stays fixed here: both calls to
 * action go through /pricing like every other road into signup
 * (`signupStartsAtPricing.test`) — only their labels are content. The
 * feature-by-feature tour is /features.
 */
export default function HomePage() {
  const { doc, shot } = useSite();
  const home = doc.home;
  const hero = shot(home.hero);
  return (
    <>
      <section className="site-hero">
        {home.eyebrow && <Link className="site-eyebrow" to={home.eyebrowLink}>{home.eyebrow}</Link>}
        <h1>{home.h1}</h1>
        {home.lede && <p className="lede">{home.lede}</p>}
        <div className="actions">
          <Link className="fs-btn ink lg" to="/pricing">{home.cta1}</Link>
          <Link className="fs-btn neutral lg" to="/pricing">{home.cta2}</Link>
        </div>
        {/* The chosen shot, cropped to the design's 2.3:1 on a desktop; its
            phone crop under 640px, where it has one. */}
        <div className="site-hero-shot" data-frame="hero-shot">
          <picture>
            {hero.phone && (
              <source media="(max-width: 640px)" srcSet={hero.phone.src} width={hero.phone.width} height={hero.phone.height} />
            )}
            <img src={hero.desktop.src} width={hero.desktop.width} height={hero.desktop.height} alt={hero.alt} />
          </picture>
        </div>
      </section>

      <div className="site-pillars-band">
        <section className="site-pillars" aria-label="What Form-Magic does">
          {home.pillars.map((p, i) => (
            <div key={i} className="site-pillar">
              <span className="k">{p.k}</span>
              <h2>{p.title}</h2>
              <p>{p.body}</p>
            </div>
          ))}
        </section>
      </div>
    </>
  );
}
